module.exports = {
  siteTitle: 'Fishcube', // Site title.
  siteTitleAlt: 'Fishcube', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://fishcube.co.uk', // Domain of your website without pathPrefix.
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Fishing application to store your catch memories logically', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  googleAnalyticsID: '',
  disqusShortname: 'Fishcube', // Disqus shortname.
  userName: 'Stuart Smith',
  userLocation: 'Bordon, uk',
  userDescription: '',
  copyright: 'Copyright © Fishcube 2020-2021. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#4DBA87', // Used for setting manifest and progress theme colors.
  backgroundColor: '#eceff1', // Used for setting manifest background color.
  crispChatId: 'b1600cdf-ea31-4a64-bf7a-efd9cb4a8e95'
}
